export default __webpack_public_path__ + "static/media/b672d460e3ebca5edbc2a4c7f4a6988c.svg";